import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import React from 'react'

import { tradeSettingsDialogParamsAtom } from '../../atoms/options-dialog-atom'

import { TradeSettingsDrawer } from './trade-settings-drawer'
import { TradeSettingsModal } from './trade-settings-modal'

import type { TradeSettingsFormProps } from './trade-settings-preset-form'

type Props = {}

export const TradeSettingsModalController = React.memo<Props>(() => {
  const [params, setParams] = useAtom(tradeSettingsDialogParamsAtom)
  const mode = params?.mode ?? 'dialog'

  const formProps: TradeSettingsFormProps | undefined = params ? {} : undefined

  return (
    <>
      <AnimatePresence>
        {params && mode === 'drawer' ? (
          <TradeSettingsDrawer
            {...formProps}
            open
            onOpenChange={(open) => {
              if (!open) {
                setParams(undefined)
              }
            }}
          />
        ) : undefined}
      </AnimatePresence>

      <AnimatePresence>
        {params && mode === 'dialog' ? (
          <TradeSettingsModal
            {...formProps}
            open
            onOpenChange={(open) => {
              if (!open) {
                setParams(undefined)
              }
            }}
          />
        ) : undefined}
      </AnimatePresence>
    </>
  )
})
